import AskWavesIcon from '../../../../../ui/svg/common/ask-waves-icon';
import { sendGAEvent } from '../../../../../domain/marketing/gtm-provider';

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-5501
 */
const ProductAskWavesBtn = () => {
    return (
        <button
            type="button"
            data-ask-waves={ true }
            onClick={ () => {
                sendGAEvent('Click', 'Ask Waves Product Page Link');
            }}
            className="flex items-center gap-2 mt-6">
            <span className="flex items-center justify-center rounded-full bg-blue-200" style={{
                width: '22px',
                height: '22px',
            }}><AskWavesIcon /></span>
            <span><span className="underline">Ask Waves about this product</span> »</span>
        </button>
    )
};

export default ProductAskWavesBtn